import React, { VFC } from 'react';
import { Route } from 'react-router-dom';

import {
  MCPR_TENRI,
  MCPR_USA,
  MCPR_FUKUSHIMA,
  MCPR_NISHIKAN,
  MCPR_SHIZUOKA,
  MCPR_IMABARI,
  MCPR_BETSUKAI,
  MCPR_ISHIKAWA,
  MCPR_TOBA,
  MCPR_KOCHI,
  MCPR_TOHOKU,
} from '../../constants/routing';
import { MunicipalityCollaborationTenriPage } from './Tenri/Loadable';
import { MunicipalityCollaborationUsaPage } from './Usa/Loadable';
import { MunicipalityCollaborationFukushimaPage } from './Fukushima/Loadable';
import { MunicipalityCollaborationNishikanPage } from './Nishikan/Loadable';
import { MunicipalityCollaborationShizuokaPage } from './Shizuoka/Loadable';
import { MunicipalityCollaborationImabariPage } from './Imabari/Loadable';
import { MunicipalityCollaborationBetsukaiPage } from './Betsukai/Loadable';
import { MunicipalityCollaborationIshikawaPage } from './Ishikawa/Loadable';
import { MunicipalityCollaborationTobaPage } from './Toba/Loadable';
import { MunicipalityCollaborationKochiPage } from './Kochi/Loadable';
import { MunicipalityCollaborationTohokuPage } from './Tohoku/Loadable';

const MunicipalityCollaborationRoute: VFC = (props) => {
  return (
    <>
      <Route
        exact
        path={MCPR_TENRI}
        component={MunicipalityCollaborationTenriPage}
      />
      <Route
        exact
        path={MCPR_USA}
        component={MunicipalityCollaborationUsaPage}
      />
      <Route
        exact
        path={MCPR_FUKUSHIMA}
        component={MunicipalityCollaborationFukushimaPage}
      />
      <Route
        exact
        path={MCPR_SHIZUOKA}
        component={MunicipalityCollaborationShizuokaPage}
      />
      <Route
        exact
        path={MCPR_NISHIKAN}
        component={MunicipalityCollaborationNishikanPage}
      />
      <Route
        exact
        path={MCPR_IMABARI}
        component={MunicipalityCollaborationImabariPage}
      />
      <Route
        exact
        path={MCPR_BETSUKAI}
        component={MunicipalityCollaborationBetsukaiPage}
      />
      <Route
        exact
        path={MCPR_ISHIKAWA}
        component={MunicipalityCollaborationIshikawaPage}
      />
      <Route
        exact
        path={MCPR_TOBA}
        component={MunicipalityCollaborationTobaPage}
      />
      <Route
        exact
        path={MCPR_KOCHI}
        component={MunicipalityCollaborationKochiPage}
      />
      <Route
        exact
        path={MCPR_TOHOKU}
        component={MunicipalityCollaborationTohokuPage}
      />
    </>
  );
};

export default MunicipalityCollaborationRoute;
